export const addMonths = (date: Date, months: number) => {
  const d = date.getDate();
  date.setMonth(date.getMonth() + months);
  if (date.getDate() !== d) {
    date.setDate(0);
  }
  return date;
};

export const formatDate = (date: Date) => {
  return date.toLocaleString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

export const getCurrentMonthYear = (): string => {
  const date = new Date();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${year}`;
};

export const getCurrentMonth = (): string => {
  const date = new Date();
  const month = String(date.getMonth() + 1);
  return `${month}`;
};

export const getCurrentYear = (): number => {
  const date = new Date();
  return date.getFullYear();
};
